module.exports = __webpack_public_path__ + "static/img/download1-4.4b771046.png";